<template>
  <component :is="layout" />
</template>

<script lang="ts" setup>
import LayoutDefault from '@/layouts/LayoutDefault.vue'
import LayoutEmpty from '@/layouts/LayoutEmpty.vue'

const isIframed = ref(false)

onMounted(() => {
  isIframed.value = window.self !== window.top
})

const layout = computed(() => (isIframed.value ? LayoutEmpty : LayoutDefault))
</script>
